"use strict";

exports.__esModule = true;
exports.resolveThemeVars = resolveThemeVars;
function resolveThemeVars(parent, child) {
  var keys = Object.keys(child);
  var theme = Object.assign({}, parent);
  for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
    var key = _keys[_i];
    theme[key] = resolveThemeVar(parent, child, key);
  }
  return theme;
}
function resolveThemeVar(parent, child, key) {
  var value = key in child ? child[key] : parent[key];
  if (typeof value === "string" && value.startsWith("$")) {
    var ref = value.slice(1);
    return resolveThemeVar(parent, child, ref);
  } else if (typeof value === "object" && value !== null) {
    var keys = Object.keys(value);
    var resolved = {};
    for (var i = 0; i < keys.length; i++) {
      resolved[keys[i]] = resolveThemeVar(parent, value, keys[i]);
    }
    return resolved;
  }
  return value;
}